import { api_url } from "../../utils/constants";
import { stripSensitiveFieldsFromList } from "../../utils/strip-sensitive-fields";
const axios = require('axios').default;

export const downloadServiceProviders = (
    requestType, 
    lowerLimit, 
    incrementSize, 
    userCountry, 
    userLat, 
    userLng, 
    range, 
    distanceUnit, 
    isOrderDistance, 
    employeeOnly,
    isForContent = false,
    withPhotoOnly = false
) => {
    return new Promise((resolve, reject) => {

        axios({
          method : "GET",
          url :  api_url + "/public/DownloadServiceProviders",
          params : {
            "requestType": requestType,
            "lowerLimit": lowerLimit,
            "incrementSize": incrementSize,
            "userCountry": userCountry,
            "userLat": userLat,
            "userLng": userLng,
            "range": range,
            "distanceUnit": distanceUnit,
            "isOrderDistance": isOrderDistance,
            "employeeOnly": employeeOnly ? true : false,
            "isForContent": isForContent ? true : false,
            "withPhotoOnly": withPhotoOnly ? true : false
          },
          headers:  { "Content-Type": "application/json", },
        })
        .then(
            (response) => {
                // Never let provider contact details reach the browser via __NEXT_DATA__.
                resolve(stripSensitiveFieldsFromList(response.data));
            }, (error) => {
                console.log(error); 
                reject(error);
            }
        )
    });
}

export const downloadTopServiceProviders = (
    requestType, 
    lowerLimit, 
    incrementSize, 
    userCountry, 
    userLat, 
    userLng, 
    range, 
    distanceUnit, 
    isOrderDistance,
    gender
) => {
    return new Promise((resolve, reject) => {

        axios({
          method : "GET",
          url :  api_url + "/public/DownloadTopServiceProviders",
          params : {
            "requestType": requestType,
            "lowerLimit": lowerLimit,
            "incrementSize": incrementSize,
            "userCountry": userCountry,
            "userLat": userLat,
            "userLng": userLng,
            "range": range,
            "distanceUnit": distanceUnit,
            "isOrderDistance": isOrderDistance,
            "gender": gender
          },
          headers:  { "Content-Type": "application/json", },
        })
        .then(
            (response) => {
                // Never let provider contact details reach the browser via __NEXT_DATA__.
                resolve(stripSensitiveFieldsFromList(response.data));
            }, (error) => {
                console.log(error); 
                reject(error);
            }
        )
    });
}